export const contactsData = {
  email: "gauravs1908@gmail.com",
  phone: "(669)210-4063",
  address: "San Jose , CA",
  github: "https://github.com/GauravYS",
  facebook: "",
  linkedIn: "https://www.linkedin.com/in/gauravshinde19/",
  twitter: "",
  medium: "",
  stackOverflow: "",
  devUsername: "",
};
